// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"3a01eb47","703":"04ae8b67"}[chunkId] + ".chunk.js";
};